
/**
 * Modal Product Gallery Constant
 * @module patterns/components/productGallery
 */

// Determine

export const CLASS_NAME = 'product-gallery-carousel'

/**
 * Options for the modal carousel.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OPTIONS = {
    gap: 0,
    classes: {
        direction: {
            ltr: 'carousel--ltr',
            rtl: 'carousel--rtl',
        },
        slider: 'carousel--slider',
        carousel: 'carousel--carousel',
        swipeable: 'carousel--swipeable',
        dragging: 'carousel--dragging',
        cloneSlide: 'carousel--clone',
        activeNav: 'carousel__bullet--active',
        activeSlide: 'carousel__slide--active',
        disabledArrow: 'carousel--disabled',
    },
};
